// extracted by mini-css-extract-plugin
module.exports = {"form":"Kv45eRUNGmrb7e6RTwRY"};